<template>
    <div class="colorComponent ">
        <div class="backgroundComponent" />

        <div class="row">
            <div class="col-12 mt-3 mr-1 text-left">       
                <img  v-if="!isItemProfil && !isComparator "   alt="" class="mb-2 d-none d-lg-inline" src="../assets/icons/fi-rr-angle-small-left.svg"  @click="close()"  style="cursor:pointer;" />  
                 
            </div>
        </div>

        <div class="boxesWrapper">
            <div class="groupButtons" :style="isItemProfil ? 'left: 40% !important;' : '' "> 
                
                <!-- v-if="this.visibleRange && this.visibleRange.start > 0"  -->

                <div class="arrowWrapper left" @click="scroll(-1)">
                    <img  alt="" class="" src="@/assets/icons/fi-rr-angle-small-left-dark.svg" :style="isArrowLeftActive ? 'opacity:1' : 'opacity:0.2'" />  

                </div>
                <div class="colorCircles">
                    <div v-for="(variant, index) in visibleVariants" :key="index" class="colorCircle" @mouseover="onMouseOver(variant)" @click="selectColor(variant)"
                        data-toggle="tooltip" data-placement="bottom" :title="variant.color.name" 
                        
                        
                        
                        :style="{ backgroundColor: variant.color.rgb, 
                                  border: (selectedColor && variant.id === selectedColor.id) ? '2px solid black' : '2px solid #121212', 
                                  
                                  opacity: isColorInStock(variant)  ? '' : '0.5', 
                                  cursor: isColorInStock(variant) ? 'pointer' : 'pointer'}">
                                  
                                  <div v-if="!isColorInStock(variant)  " style="margin-top:1px; color:#808080;">
                                    <img  alt="" width="20px" class="" src="../assets/icons/fi-rr-cross-small.svg" style="cursor: pointer; "  />  

                                </div>

                               
                                  <div v-else-if="selectedColor && variant.color.id === selectedColor.color.id" style="margin-top:1px; color:#fff;">
                                    
                                    <img  alt="" width="22px" class="" src="../assets/icons/fi-rr-check-white.svg"  />  

                                </div>


                    </div>
                </div>

                <!-- v-if="this.visibleRange && this.variants && this.visibleRange.end < this.variants.length - 1" -->

                <div class="arrowWrapper right" @click="scroll(1)">
                    <img  alt="" class="" src="@/assets/icons/fi-rr-angle-small-right-dark.svg"  :style="isArrowRightActive ? 'opacity:1' : 'opacity:0.2'" />  

                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: "ColorComponent",

    components: {},


    props: {
        sizesList: Object,
        selectedSize: String,
        isItemProfil:Boolean,
        isComparator: Boolean,
        available:{
          type:Boolean,
          default:false
        },
    },
    data() {
        return {
            visibleRange: { start: 0, end: 4 }, // Initial visible range
            selectedColor: null,

            hoveredVariant: null,
        };
    },

    computed: {

        isArrowRightActive() {
            return this.visibleRange && this.variants && this.visibleRange.end < this.variants.length - 1
        },

        isArrowLeftActive() {
            return this.visibleRange && this.visibleRange.start > 0
        },

        visibleVariants() {
            return  this.variants ? this.variants.slice(this.visibleRange.start, this.visibleRange.end + 1) : null;
        },

        variants() {

            if (!this.sizesList) {
                return null;
            }

            if (!this.selectedSize) {
                return this.allVariants;
            }

            return this.sizesList[this.selectedSize];
        },

       /*allVariants() {
            let list = [];
            Object.keys(this.sizesList).forEach(sizeKey => {
                // Concatenate the arrays associated with each key
                list = list.concat(this.sizesList[sizeKey]);
            }); 
            return list;
        }, */

        allVariants() {
            let uniqueObjects = {};
            Object.values(this.sizesList).forEach(sizeArray => {
                sizeArray.forEach(item => {
                    // Use the color name as a unique identifier
                    const colorName = item.color.name;
                    // Add the object to the dictionary if it doesn't exist
                    if (!uniqueObjects[colorName]) {
                        uniqueObjects[colorName] = item;
                    }
                });
            }); 
            // Convert the dictionary back to an array of objects
            return Object.values(uniqueObjects);
        },

        colorList() {
            return null;
            /*if (!this.variant) {
                return null;
            }

            return this.variant.color;*/
        },
    },
    methods: {

        getTotalStockOfColor( colorId) {
            return Object.entries(this.sizesList)
            .filter(([size]) => !this.selectedSize || size === this.selectedSize)
            .flatMap(([, items]) => items)
            .filter(item => item.color.id === colorId)
            .reduce((total, item) => total + item.stock, 0);
        },


        isColorInStock(variant) {

            if(this.getTotalStockOfColor(variant.color.id) || variant.stock ) {
                return true ;
            }

            if (this.available) {
                return true;
            }
            return false;
        },
        scroll(direction) {
            const step = 1; // Number of colors to scroll

            if (direction === 1) {
                // Scroll right
                if (this.visibleRange.end < this.variants.length - 1) {
                    this.visibleRange.start = Math.min(this.visibleRange.start + step, this.variants.length - 5);
                    this.visibleRange.end = Math.min(this.visibleRange.end + step, this.variants.length - 1);
                }
            } else if (direction === -1) {
                // Scroll left
                if (this.visibleRange.start > 0) {
                    this.visibleRange.start = Math.max(this.visibleRange.start - step, 0);
                    this.visibleRange.end = Math.max(this.visibleRange.end - step, 4);
                }
            }
        },

        close() {
            this.$emit("close");
        },

        onMouseOver(variant) {
            this.hoveredVariant = variant;
            this.$emit("mouseover", variant);
        },

        selectColor(variant) {   
           
            if (this.selectedColor && this.selectedColor.id == variant.id) {
                this.selectedColor = null;
                this.$emit('color-selected', null);
            } else {
                this.selectedColor = variant;
                this.$emit('color-selected', variant);
            }
        },
    },
};
</script>
  
<style scoped>
.colorComponent {
    position: relative;
    width: 100%;
    height: 52px;
    text-align: center;
    font-size: 14px;
    color: #121212;
    font-family: Inter;
}

.colorCircles {
    display: flex;
    align-items: center;
}

.colorCircle {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin: 0 5px;
    border: 2px solid #121212;
    cursor: pointer;
    transition: border-color 0.3s, transform 0.3s; 
}

.colorCircle:hover {
    border: 2px solid black;
    transform: scale(1.5); 
}

.color-circle-disable-hover:hover {
  /* Override hover effect when applyHover is false */
  border: none;
  transform: none;
}

.arrowWrapper {
    cursor: pointer;
}

.arrowIcon {
    width: 20px;
    height: 20px;
}

.backgroundComponent {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0%;
    right: 0%;
    bottom: 0%;
    left: 0%;
    background-color: rgba(255, 255, 255, 0.7);
}

.boxesWrapper {
    position: absolute;
    height: 73.08%;
    width: 92.93%;
    top: 13.46%;
    right: 3.53%;
    bottom: 13.46%;
    left: 3.53%;
}

.groupButtons {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
}
</style>
